export const servicesByContractId = {
    ['contractId1']: [
        {
            id: 'serviceId1',
            name: 'testService1',
            status: 'published',
            adviser_authorisation_limit: '123.99',
            start_date: '1 November 2023',
            end_date: '18 November 2024',
            claim_file_prefix: 'abcd',
            company_name: 'acme',
            contract: {
                id: 'contractId1',
                name: 'testContract1',
                contract: 'testContract1',
                status: 'published',
                unique_identifier_type: {
                    id: 'uniqueIdentifierTypeId2',
                    name: 'NINO',
                    status: 'published'
                },
                contract_type: {
                    id: 'contractTypeId1',
                    name: 'EMPLOYABILITY',
                    status: 'published'
                }
            }
        },

        {
            id: 'serviceId2',
            name: 'testService2',
            status: 'published',
            adviser_authorisation_limit: '456.99',
            start_date: '1 July 2023',
            end_date: '18 July 2024',
            claim_file_prefix: 'abcdef',
            company_name: 'acme',
            contract: {
                id: 'contractId1',
                name: 'testContract1',
                contract: 'testContract1',
                status: 'published',
                unique_identifier_type: {
                    id: 'uniqueIdentifierTypeId2',
                    name: 'NINO',
                    status: 'published'
                },
                contract_type: {
                    id: 'contractTypeId1',
                    name: 'EMPLOYABILITY',
                    status: 'published'
                }
            }
        }
    ],
    ['contractId2']: [
        {
            id: 'serviceId2',
            name: 'testService2',
            status: 'published',
            adviser_authorisation_limit: '456.99',
            start_date: '1 July 2023',
            end_date: '18 July 2024',
            claim_file_prefix: 'abcdef',
            company_name: 'acme',
            contract: {
                id: 'contractId2',
                name: 'testContract2',
                contract: 'testContract2',
                status: 'published',
                unique_identifier_type: {
                    id: 'uniqueIdentifierTypeId2',
                    name: 'NINO',
                    status: 'published'
                },
                contract_type: {
                    id: 'contractTypeId2',
                    name: 'EMPLOYABILITY',
                    status: 'published'
                }
            }
        },

        {
            id: 'serviceId3',
            name: 'testService3',
            status: 'published',
            adviser_authorisation_limit: '456.99',
            start_date: '1 July 2023',
            end_date: '18 July 2024',
            claim_file_prefix: 'abcdef',
            company_name: 'acme',
            contract: {
                id: 'contractId2',
                name: 'testContract2',
                contract: 'testContract2',
                status: 'published',
                unique_identifier_type: {
                    id: 'uniqueIdentifierTypeId2',
                    name: 'NINO',
                    status: 'published'
                },
                contract_type: {
                    id: 'contractTypeId2',
                    name: 'EMPLOYABILITY',
                    status: 'published'
                }
            }
        }
    ],
    ['contractId3']: [
        {
            id: 'serviceId2',
            name: 'testService2',
            status: 'published',
            adviser_authorisation_limit: '456.99',
            start_date: '1 July 2023',
            end_date: '18 July 2024',
            claim_file_prefix: 'abcdef',
            company_name: 'acme',
            contract: {
                id: 'contractId3',
                name: 'testContract3',
                contract: 'testContract3',
                status: 'published',
                unique_identifier_type: {
                    id: 'uniqueIdentifierTypeId2',
                    name: 'NINO',
                    status: 'published'
                },
                contract_type: {
                    id: 'contractTypeId2',
                    name: 'EMPLOYABILITY',
                    status: 'published'
                }
            }
        },

        {
            id: 'serviceId3',
            name: 'testService3',
            status: 'published',
            adviser_authorisation_limit: '456.99',
            start_date: '1 July 2023',
            end_date: '18 July 2024',
            claim_file_prefix: 'abcdef',
            company_name: 'acme',
            contract: {
                id: 'contractId2',
                name: 'testContract2',
                contract: 'testContract2',
                status: 'published',
                unique_identifier_type: {
                    id: 'uniqueIdentifierTypeId2',
                    name: 'NINO',
                    status: 'published'
                },
                contract_type: {
                    id: 'contractTypeId2',
                    name: 'EMPLOYABILITY',
                    status: 'published'
                }
            }
        }
    ]
};
